import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { AppointmentSlotDetailViewModel } from 'projects/Administration/src/app/business-entities/appointment-slot-detail-view-model';
import { AppointmentList } from 'projects/Administration/src/app/business-entities/appointmentList-model';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
declare let $: any;
@Component({
  selector: 'app-appointment-slot-detail',
  templateUrl: './appointment-slot-detail.component.html',
  styleUrls: ['./appointment-slot-detail.component.css']
})
export class AppointmentSlotDetailComponent implements OnInit,OnChanges  {
  @Input() appointmentSlotDetails: any;
  @Input() slotAppointment: AppointmentSlotDetailViewModel;
  @Input() slotDetailPosition: number;
  @Input() idSpaceFromPlannerTopOffset: number;
  @ViewChild('slotPosition') elementView: ElementRef;
  @Input() dealerName: string;
  @Input() isView:boolean;
  @Input() showTotalHours: boolean = false; 
  @Output() isDisplayMouseHoverDetail: EventEmitter<any> = new EventEmitter();
  appointmentStartDate: string;
  appointmentEndDate: string;
  appointmentDetails:AppointmentList
  constructor(private datePipe: DatePipe, private readonly editAppointmentService: EditAppointmentService) { }

  ngOnInit(): void {
    if(!this.isView){
      this.appointmentDetails = this.editAppointmentService.appointmentDetails;
    }
    this.SetDates();
  }
  ngAfterViewInit(): void {
    let height = this.elementView.nativeElement.offsetHeight;
    if (height < this.idSpaceFromPlannerTopOffset) {
      $('#pop-box_day_mechId').css({ bottom: 15, top: 'inherit' });
    } else {
      $('#pop-box_day_mechId').css({ top: 0, bottom: 'inherit' });
    }

    $('#pop-box_day_mechId').offset({ left: this.slotDetailPosition + 10 });
  }
  ngOnChanges() {
    this.SetDates();
  }
  SetDates() {
    this.appointmentStartDate = this.appointmentSlotDetails.appointmentStartTime ?
      this.datePipe.transform(new Date(this.appointmentSlotDetails.appointmentStartTime), "dd.MM.yyyy HH:mm") : "";
    this.appointmentEndDate = this.appointmentSlotDetails.appointmentEndTime ?
      this.datePipe.transform(new Date(this.appointmentSlotDetails.appointmentEndTime), "dd.MM.yyyy HH:mm") : "";
  }

  GetSlotBackGroundColor(slotAppointmentColor): object {
    return { 'backgroundColor': '#' + slotAppointmentColor };
  }

  GetSlotBlockBorderColor(slotAppointmentColor): object {
    return { "border-color": '#' + slotAppointmentColor };
  }

  ClosePopupDetail(e:Event) {
    this.appointmentSlotDetails.isDisplayMouseHoverDetail = false;
    this.isDisplayMouseHoverDetail.emit(e);
  }

  FormatDemandDescription(description: string): string[] {
    if (description) {
      description = description.replace(/^,|,$/g, '').trim(); 
      return description.split(',').map(item => item.trim());
    }
    return [];
  }

  get isAnyWarrantyDemand(): boolean {
    return this.appointmentSlotDetails?.appointmentDemands?.some(demand => demand.isUnderWarranty) || false;
  }
}
